module.exports = __webpack_public_path__ + "img/Group792.d6c5badb.png";